import {
  BOOK_COMPONENT_CATEGORY_IDS,
  HARDWARE_PRODUCT_TYPE_ID,
} from "constants/config";

const getOrderShippingAddress = (order) =>
  order?.addressDetails?.shippingAddress ||
  order?.shippingAddress ||
  order?.addressDetails?.shipping_address ||
  order?.shipping_address ||
  null;

export const orderHadShippingAddress = (order) => {
  const shipping = getOrderShippingAddress(order);
  if (!shipping || typeof shipping !== "object") {
    return false;
  }

  return Boolean(
    shipping.addressLine1 ||
      shipping.address_line_1 ||
      shipping.city ||
      shipping.recipientName ||
      shipping.recipient_name ||
      shipping.postalCodeId ||
      shipping.postal_code_id ||
      shipping.districtName ||
      shipping.district_name
  );
};

export const cartRequiresShippingAddress = (
  selectedPackageSubscriptions = []
) =>
  selectedPackageSubscriptions.some(
    (pkg) =>
      (pkg.componentProductTypeIds || []).includes(HARDWARE_PRODUCT_TYPE_ID) ||
      (pkg.componentCategoryIds || []).some((categoryId) =>
        BOOK_COMPONENT_CATEGORY_IDS.includes(categoryId)
      )
  );

export const resolveRequiresShippingAddress = (
  selectedPackageSubscriptions,
  previousOrderHadShipping = false
) =>
  cartRequiresShippingAddress(selectedPackageSubscriptions) ||
  Boolean(previousOrderHadShipping);
